<template>
  <v-app dark style="background-color: #f8f8f8">
    <!-- #011144"> -->
    <div>
      <v-img max-height="70" :src="headerPath">
        <div
          style="
            color: white;
            float: right;
            margin-top: 30px;
            margin-right: 2%;
            font-size: 1.23rem;
            text-shadow: 0 0 5px #000;
          "
        >
          Hello {{ $store.state.eventInfo.VendorName }}
        </div>
      </v-img>
      <v-toolbar dense flat>
        <v-card
          color="transparent"
          flat
          style="margin-top: -70px; border-radius: 0px"
        >
          <img
            @click="openHome"
            :src="logoPath"
            style="cursor: pointer; border-radius: 0px 0px 20px 20px"
            :width="this.$vuetify.breakpoint.smAndDown ? '130px' : '230px'"
          />
        </v-card>
        <v-toolbar-title class="ml-4"
          ><h4>{{ $store.state.pageTitle }}</h4></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn
          outlined
          color="primary"
          @click="openHome"
          class="hidden-sm-and-down"
          ><v-icon left>mdi-dots-grid</v-icon> Dashboard</v-btn
        >
        <v-btn
          outlined
          color="primary"
          class="ml-2 hidden-sm-and-down"
          @click="openReports"
          ><v-icon left>mdi-finance</v-icon> App. Summary</v-btn
        >
        <v-btn
          outlined
          class="ml-2 hidden-sm-and-down"
          :disabled="
            this.$store.state.Deadline != 'open' ||
            this.$store.state.isLimitOver == true
              ? true
              : false
          "
          color="primary"
          @click="openNewApplication"
          ><v-icon left>mdi-plus-thick</v-icon> New Application</v-btn
        >
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              icon
              v-bind="attrs"
              v-on="on"
              class="ml-2"
              color="primary"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="openHome">
              <v-list-item-title
                ><v-icon color="primary" left>mdi-dots-grid</v-icon>
                Dashboard</v-list-item-title
              >
            </v-list-item>
            <v-list-item @click="openReports">
              <v-list-item-title
                ><v-icon color="primary" left>mdi-finance</v-icon> App.
                Summary</v-list-item-title
              >
            </v-list-item>
            <v-list-item
              @click="openNewApplication"
              :disabled="
                this.$store.state.Deadline != 'open' ||
                this.$store.state.isLimitOver == true
                  ? true
                  : false
              "
            >
              <v-list-item-title
                ><v-icon color="primary" left>mdi-plus-thick</v-icon> New
                Application</v-list-item-title
              >
            </v-list-item>
            <v-list-item
              @click="openImportApplication"
              v-if="
                this.$store.state.Deadline == 'open' &&
                this.$store.state.isLimitOver == false &&
                this.$store.state.eventInfo.IsImport == 'Y'
              "
            >
              <v-list-item-title
                ><v-icon color="primary" left>mdi-file-import-outline</v-icon>
                Import Application</v-list-item-title
              >
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="$router.push('/app/profile').catch({})">
              <v-list-item-title
                ><v-icon color="primary" left>mdi-account</v-icon> Company
                Profile</v-list-item-title
              >
            </v-list-item>
            <!-- <v-divider></v-divider>
            <v-list-item @click="$router.push('/changepassword').catch({})">
              <v-list-item-title>Change Password</v-list-item-title>
            </v-list-item> -->
            <v-divider></v-divider>
            <v-list-item color="error" @click="logout">
              <v-list-item-title
                ><v-icon color="primary" left>mdi-logout</v-icon>
                Logout</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
    </div>
    <v-main>
      <div class="mb-10">
        <router-view></router-view>
      </div>
    </v-main>
    <v-footer dark class="pt-1 pb-1">
      <v-card width="100%">
        <v-card-actions class="pa-1" style="font-size: 0.9rem">
          <span>&copy; {{ new Date().getFullYear() }}</span>
          <v-spacer></v-spacer>
          Powered By
          <img src="/DNA-Logo-mono.png" height="45px" class="pl-3" alt="" />
        </v-card-actions>
      </v-card>
    </v-footer>
    <v-dialog
      v-model="importDialog"
      scrollable
      persistent
      max-width="900px"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title style="font-size: 1.1rem">
          Import Application
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="padding: 10px 20px">
          <div style="font-size: 1.2rem; color: #000; font-weight: 600">
            Event Name : {{ $store.state.eventInfo.ImportEventName }}
          </div>
          <div style="margin-top: 20px">
            <v-row>
              <v-col cols="8">
                <v-text-field
                  v-model="importAppId"
                  hide-details
                  outlined
                  label="Enter App Id *"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-btn
                  x-large
                  color="info"
                  @click="fetchApplication"
                  :loading="isLoading"
                  ><v-icon size="25px" left>mdi-download-outline</v-icon>
                  FETCH</v-btn
                >
              </v-col>
            </v-row>
          </div>
          <v-divider />
          <div>
            <v-card v-if="fetchedData.app_id">
              <v-card-title style="font-size: 1.1rem">
                {{ fetchedData.app_id }} - {{ fetchedData.fName }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text style="padding: 10px 20px; color: #000">
                <v-row>
                  <v-col cols="2">
                    <img
                      :src="getImgPath(fetchedData.picHeadShot)"
                      style="
                        width: 100%;
                        max-width: 90px;
                        border-radius: 20px;
                        border: 1px solid #ddd;
                      "
                    />
                  </v-col>
                  <v-col cols="7">
                    <b> {{ fetchedData.fName }} {{ fetchedData.lName }}</b
                    ><br />
                    Company Type : {{ fetchedData.companytype_name }}<br />
                    Company Name : {{ fetchedData.company_name }}<br />
                    ID Proof : {{ fetchedData.idProofType }} -
                    {{ fetchedData.idProofNumber }}<br />
                  </v-col>
                  <v-col cols="2">
                    <v-btn
                      class="pl-8 pr-8"
                      x-large
                      color="success"
                      :loading="isLoading"
                      @click="
                        importSelectedApplication(fetchedData.application_id)
                      "
                      ><v-icon size="25px" left>mdi-file-import-outline</v-icon>
                      IMPORT</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="importDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar top v-model="alert.show" :color="alert.color">
      {{ alert.msg }}
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  props: { EventUrl: String },
  data() {
    return {
      alert: {
        color: "success",
        msg: "",
        show: false,
      },
      isLoading: false,
      logoPath: "",
      headerPath: "",
      clipped: false,
      drawer: true,
      fixed: false,
      cpDialog: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      importDialog: false,
      importAppId: "",
      fetchedData: {},
      menuitems: [
        { title: "Profile" },
        { title: "Change Password" },
        { title: "Logout" },
      ],
    };
  },
  created() {
    //console.log(this.$store.state.eventInfo);

    if (this.$store.state.eventInfo.VendorId == "") {
      this.$router
        .push("/" + this.$store.state.eventInfo.EventUrl + "/login")
        .catch(() => {});
    }
    this.logoPath =
      this.$apiPhotoPath +
      "/assets/" +
      this.$store.state.eventInfo.EventUrl +
      "/logo.jpg";
    this.headerPath =
      this.$apiPhotoPath +
      "/assets/" +
      this.$store.state.eventInfo.EventUrl +
      "/header.jpg";
  },
  methods: {
    // getOpenStatus() {
    //   let result =false;

    //   if (this.$store.state.eventInfo.Deadline != "open") {
    //     result= true;
    //   }
    //   if (this.$store.state.isLimitOver == true) {
    //     result= true;
    //   }
    //   return result;
    // },
    showMsg: function (color, msg) {
      this.alert.color = color;
      this.alert.msg = msg;
      this.alert.show = true;
    },
    getImgPath(fileName) {
      if (fileName == "" || fileName == null) {
        return "../images/nophoto.png";
      } else {
        return this.$apiPhotoPath + "/" + fileName;
      }
    },
    openNewApplication: function () {
      this.$store.commit("resetApplication");
      this.$router.push("/app/newapplication").catch(() => {});
    },
    openImportApplication: function () {
      this.$router.push("/app/dashboard").catch(() => {});
      this.fetchedData = {};
      this.importDialog = true;
    },
    fetchApplication: async function () {
      this.isLoading = true;
      await this.$axios
        .get(
          `/Application/forImport/${this.$store.state.eventInfo.ImportEventId}/${this.importAppId}`
        )
        .then((res) => {
          const vv = res.data;

          if (vv.message == "NOTEXISTS") {
            this.fetchedData = {};
            this.showMsg("error", "Application Not Found!");
          } else this.fetchedData = vv.result;

          this.isLoading = false;
        });
    },
    importSelectedApplication: async function (appid) {
      this.isLoading = true;
      await this.$axios
        .post("Application/importApplication", { application_id: appid })
        .then((res) => {
          this.appData = res.data.result;
          this.importDialog = false;

          this.isLoading = false;
          this.$router.push("/app/reports").catch(() => {});
        });
    },
    openReports: function () {
      this.$router.push("/app/reports").catch(() => {});
    },
    openHome: function () {
      this.$router.push("/app/dashboard").catch(() => {});
    },
    logout: function () {
      this.$store.commit("logout");
      this.$router
        .push("/" + this.$store.state.eventInfo.EventUrl + "/login")
        .catch(() => {});
    },
  },
};
</script>
<style>
.cardHeader {
  background-color: #fbfbfb;
  padding: 8px;
  padding-left: 10px;
  border-left: 3px solid rgb(75, 35, 250);
  font-weight: 500;
  font-size: 1.05rem;
  color: gray;
}
</style>